/* istanbul ignore file */

export const FREE_UK_DELIVERY = 'Free UK Delivery';
